import { render, staticRenderFns } from "./helloVue.vue?vue&type=template&id=030ff70b&scoped=true&"
import script from "./helloVue.vue?vue&type=script&lang=js&"
export * from "./helloVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030ff70b",
  null
  
)

export default component.exports